import { useEffect } from 'react';

export function useEffectOnce(callback: (() => void) | (() => void)) {
  useEffect(() => callback(), []);
}
